import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { defineMessages } from 'react-intl';
import MenuInputWithTitle from '../components/MenuInputWithTitle';

const messages = defineMessages({
  grant: {
    id: 'avg.amount.aid.grant',
    defaultMessage: 'Grant',
  },
  pellGrant: {
    id: 'avg.amount.aid.pellGrant',
    defaultMessage: 'Pell Grant',
  },
  loan: {
    id: 'avg.amount.aid.loan',
    defaultMessage: 'Federal Student Loan',
  },
});

const AvgAmountOfAid = ({ onChange, initialValue }) => {
  const grant = get(initialValue, 'grant.value', '') || '';
  const pellGrant = get(initialValue, 'pellGrant.value', '') || '';
  const studentLoan = get(initialValue, 'studentLoan.value', '') || '';
  const showGrantError = get(initialValue, 'grant.showError', false);
  const showPellGrantError = get(initialValue, 'pellGrant.showError', false);
  const showStudentLoanError = get(initialValue, 'studentLoan.showError', false);
  return (
    <React.Fragment>
      <MenuInputWithTitle
        inputId="amount-of-aid-grant"
        title={messages.grant}
        value={grant}
        onChange={(e) => {
          onChange(e, {
            grant: { ...initialValue.grant, value: e.target.value },
          });
        }}
        isErrorVisible={showGrantError}
      />
      <MenuInputWithTitle
        inputId="amount-of-aid-pellgrant"
        title={messages.pellGrant}
        value={pellGrant}
        onChange={(e) => {
          onChange(e, {
            pellGrant: { ...initialValue.pellGrant, value: e.target.value },
          });
        }}
        isErrorVisible={showPellGrantError}
      />
      <MenuInputWithTitle
        inputId="amount-of-aid-loan"
        title={messages.loan}
        value={studentLoan}
        onChange={(e) => {
          onChange(e, {
            studentLoan: { ...initialValue.studentLoan, value: e.target.value },
          });
        }}
        isErrorVisible={showStudentLoanError}
      />
    </React.Fragment>
  );
};
AvgAmountOfAid.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

export default AvgAmountOfAid;
